export const drawers = {
  left:  { light: "#f8fafc", dark: "#1e293b" },
  right: { light: "#f8fafc", dark: "#1e293b" },
  bottom:{ light: "#f8fafc", dark: "#1e293b" }
};
